import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '.abyss-divider-root': {
    backgroundColor: 'var(--abyss-colors-gray2)',
    marginBottom: 'var(--abyss-space-lg) !important',
    marginTop: 'var(--abyss-space-xl) !important',
  },
});
